<template>
    <div class="drop collapse" id="editCardBlock">
        <PaymentForm
            ref="paymentForm"
            :input_countries="countries"
            :input_states="states"
            :input_payment="inner_payment"
        >
        </PaymentForm>
    </div>
</template>

<script>
    import { googleAutocomplete } from '../../mixins/google-autocomplete';
    import PaymentForm from "../Common/PaymentForm";

    export default {
        name: "PaymentCardBillingEdit",
        components: {
            PaymentForm
        },
        mixins: [ googleAutocomplete ],
        props: {
            countries: {
                type: Array,
                required: true
            },
            states: {
                type: Array,
                required: true
            },
            inner_payment: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                payment: {
                    payment_type: 'authorizeNet',
                    card_type: null,
                    card_first_name: null,
                    card_last_name: null,
                    card_number: null,
                    card_expiration_month: null,
                    card_expiration_year: null,
                    card_cvv: null,
                },
                billing: {
                    billing_first_name: null,
                    billing_last_name: null,
                    billing_street: null,
                    billing_country_id: null,
                    billing_city: null,
                    billing_state_id: null,
                    billing_zip_code: null,
                    billing_email: null,
                    billing_phone: null
                }
            }
        },
        mounted() {
            $('#editCardBlock').collapse()
        },
    }
</script>

<style scoped lang="less">
    .selected-card {
        border: 2px solid #f7c44e;
        border-radius: 5px;
    }

    .lbl.lbl-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 14px;
        font-weight: 400;
        padding-left: 5px;
    }

    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance:none;
    }
</style>
